import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import {RootRouter} from './routes/index';
import * as serviceWorker from './serviceWorker';
import { LocaleProvider } from 'antd';
import zh_CN from 'antd/lib/locale-provider/zh_CN';
// import '//at.alicdn.com/t/font_8d5l8fzk5b87iudi.js'
const render = () => {
  ReactDOM.render(
    <LocaleProvider locale={zh_CN}>
      <RootRouter />
    </LocaleProvider>, document.getElementById('root'));
}

render()

serviceWorker.unregister();
